<div class="form-dialog">
  <h2 mat-dialog-title class="dialog-title">
    Display Settings
    <span class="close-icon" (click)="onCancel()">
      <i class="fas fa-times"></i>
    </span>
  </h2>

  <mat-dialog-content class="dialog-content">
    <p class="hint">
      Choose which optional inputs appear on the invoice details panel.
    </p>

    <div class="section-label">Optional fields</div>

    <div class="setting-row" *ngIf="isXero">
      <mat-checkbox [(ngModel)]="settings.fields.xeroTrackingCategories">
        Tracking Categories
      </mat-checkbox>
    </div>

    <div class="setting-row" *ngIf="isQuickBook">
      <mat-checkbox [(ngModel)]="settings.fields.classes">
        Classes
      </mat-checkbox>
    </div>

    <div class="setting-row">
      <mat-checkbox [(ngModel)]="settings.fields.customSyncedFields">
        Custom Synced Fields
      </mat-checkbox>
    </div>

    <div class="setting-row" *ngIf="isXero">
      <mat-checkbox [(ngModel)]="settings.fields.plannedDate">
        Planned Date
      </mat-checkbox>
    </div>

    <div class="setting-row" *ngIf="isQuickBook">
      <mat-checkbox [(ngModel)]="settings.fields.customerField">
        Customer
      </mat-checkbox>
    </div>

    <div class="section-label">Account dropdown</div>
    <label class="radio-row">
      <input type="radio" name="accountDisplay" value="nameOnly"
             [(ngModel)]="settings.accountDisplay" [ngModelOptions]="{standalone: true}">
      Name only
    </label>
    <label class="radio-row">
      <input type="radio" name="accountDisplay" value="codeAndName"
             [(ngModel)]="settings.accountDisplay" [ngModelOptions]="{standalone: true}">
      Account Code + Name
    </label>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button type="button" class="custom_button line" (click)="onCancel()">
      Cancel
    </button>
    <button type="button" class="custom_button yellow" [disabled]="saving" (click)="onSave()">
      Save
    </button>
  </mat-dialog-actions>
</div>
